/* eslint-disable no-undef */
/* eslint-disable no-console */

import instance from '../api/userApi';
//import _ from 'lodash';


export const BlogsFetch = () => {

  
    return async (dispatch) => {
        
        try {

            const response = await instance.get('/blogsFetch');

            dispatch({
                type: 'blogs_fetch',
                payload: response.data
            });
//console.log( response.data)
        } catch (e) {
            alert(e)
            console.log('fetching' + e)
        }
    }
}

export const BlogFetch = (title) => {
  
    return async (dispatch) => {
        
        try {

            const response = await instance.get(`/blogFetch/${title}`);

            dispatch({
                type: 'blog_fetch',
                payload: response.data
            });
//console.log( response.data)
        } catch (e) {
            alert(e)
            console.log('blog fetching' + e)
        }
    }
}
